import {
  PPA_APPLICATION_DATA_REQUEST,
  PPA_APPLICATION_DATA_SUCCESS,
  PPA_APPLICATION_DATA_FAIL,
} from '../constants/ppaApplicationConstants';

export const ppaApplicationReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case PPA_APPLICATION_DATA_REQUEST:
      return { loading: true, formData: [] };
    case PPA_APPLICATION_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case PPA_APPLICATION_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
